import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, adminOnly = false, partnerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="font-mono-plex text-sm text-zinc-500">Loading_</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (partnerOnly && user.role !== "partner") return <Navigate to="/dashboard" replace />;

  // Auto-route partners to their portal whenever they hit the regular shipper dashboard
  const path = window.location.pathname;
  if (user.role === "partner" && !partnerOnly && !path.startsWith("/partner")) {
    return <Navigate to="/partner" replace />;
  }

  // If pending, force the pending view (unless already there or admin)
  if (user.approval_status === "pending" && user.role !== "admin" && user.role !== "partner" && path !== "/dashboard/pending" && !path.startsWith("/dashboard/addresses") && !path.startsWith("/dashboard/smart-services") && !path.startsWith("/dashboard/settings")) {
    return <Navigate to="/dashboard/pending" replace />;
  }
  return children;
}
